import type { ReactNode } from 'react';

import Tooltip from '@cartwhl/ui/atoms/Tooltip';

import { ASSET_LIBRARY_DELETE_OWN_ITEM_TOOLTIP } from '../assetLibraryAssetLifecycle';

export default function AssetLibraryBlockedActionTooltip({
  disabled,
  children,
  inModal = false,
  className,
  side = 'bottom',
  text = ASSET_LIBRARY_DELETE_OWN_ITEM_TOOLTIP,
}: {
  disabled: boolean;
  children: React.ReactNode;
  inModal?: boolean;
  className?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  text?: string;
}) {
  return (
    <Tooltip text={text} disabled={!disabled} inModal={inModal} side={side}>
      {disabled ? (
        <span className={className ?? 'inline-flex'}>{children}</span>
      ) : (
        children
      )}
    </Tooltip>
  );
}
